import type { ShopDto } from "../generated/schema.ts";
import { useQueryClient } from "@tanstack/react-query";
import { useApiMutation } from "./use-api-mutation";

export function useResetShippingboHooks(shop: ShopDto) {
  const invalidateShippingBoHooks = useInvalidateShippingBoHooks({ shopId: shop.id });

  return useApiMutation<"post", "/shops/{shopId}/integrations/shippingbo/hooks/reset", void>(
    "post",
    "/shops/{shopId}/integrations/shippingbo/hooks/reset",
    {
      invalidate: invalidateShippingBoHooks,
      mapVariables: () => ({
        params: { path: { shopId: shop.id } },
      }),
    },
  );
}

export const useInvalidateShippingBoHooks = ({ shopId }: { shopId: string }) => {
  const queryClient = useQueryClient();
  return () => {
    queryClient.invalidateQueries({
      queryKey: ["get", "/shops/{shopId}/integrations/shippingbo/hooks", { params: { path: { shopId } } }],
    });
  };
};